import { useCallback } from 'react';
import { requestDeviceUpdate } from 'console/redux/devices/items/actions';
import { getAdditionalUISettings } from 'features/settings-master/lib/additional-settings/ui-settings';
import { getAdditionalGraphsConfig } from 'features/settings-master/lib/additional-settings/graphs-config';
import { useAction } from 'shared/hooks/redux/hooks';
export const useAdditionalSaveSettingsMaster = (device_id, path) => {
    const _onRequestDeviceUpdate = useAction(requestDeviceUpdate);
    const setter = useCallback((config) => ({
        is_configured_by_wizard: true,
        server_notifications: {
            events: {
                enabled: false,
            },
            offline: {
                enabled: true,
                timeout: 1200,
            },
        },
        hide_titles_on_heat_tab: true,
        cams_show: false,
        ui_settings: getAdditionalUISettings(path),
        graphs_config: {
            blocks: getAdditionalGraphsConfig(path, config),
        },
    }), [path]);
    const result_function = useCallback((config) => {
        if (device_id == null || config == null) {
            return;
        }
        _onRequestDeviceUpdate(device_id, setter(config));
    }, [device_id, setter]);
    return result_function;
};
